import type { GameResult } from './types.js';

const TABLE: Record<string, GameResult> = {
  '1-0': { white: '1', black: '0' },
  '0-1': { white: '0', black: '1' },
  '1/2-1/2': { white: '=', black: '=' },
  '½-½': { white: '=', black: '=' },
  '1/2': { white: '=', black: '=' },
  '=': { white: '=', black: '=' },
  draw: { white: '=', black: '=' },
  '+-': { white: '+', black: '-' },
  '-+': { white: '-', black: '+' },
  '--': { white: '-', black: '-' },
  '0-0': { white: '0', black: '0' },
  '1-0u': { white: 'W', black: 'L' },
  '0-1u': { white: 'L', black: 'W' },
  '=u': { white: 'D', black: 'D' },
  '*': { white: '*', black: '*' },
};

/**
 * Parse a result as typed by an arbiter: "1-0", "0-1", "1/2", "½-½", "=",
 * "+-" (white wins by forfeit), "-+", "--" (double forfeit), "0-0",
 * "1-0u"/"0-1u"/"=u" (played but not rated), "*" (no result yet).
 */
export function parseGameResult(text: string): GameResult {
  const key = text.trim().toLowerCase().replace(/\s+/g, '');
  const r = TABLE[key];
  if (r === undefined) throw new Error(`unknown result "${text}"`);
  return r;
}

export function formatGameResult(r: GameResult): string {
  const { white: w, black: b } = r;
  if (w === '*' || b === '*') return '*';
  if (w === '1' && b === '0') return '1-0';
  if (w === '0' && b === '1') return '0-1';
  if (w === '=' && b === '=') return '½-½';
  if (w === '+' && b === '-') return '+ -';
  if (w === '-' && b === '+') return '- +';
  if (w === '-' && b === '-') return '- -';
  if (w === 'W' && b === 'L') return '1-0 (unrated)';
  if (w === 'L' && b === 'W') return '0-1 (unrated)';
  if (w === 'D' && b === 'D') return '½-½ (unrated)';
  return `${w}:${b}`;
}
